import { connectHook } from 'app/common/components/connect-hook';
import { ProjectUsers } from './project-users.js';
import { useProjectUsers } from './project-users-hook.js';

export default connectHook(ProjectUsers, useProjectUsers);
